import { createElement } from 'react';

import type { IconProps } from '../icon/icon';
import { Icon } from '../icon/icon'; // props is just passed in to keep variables.jsx happy. We don’t use variables.props
const SvgSearchIcon = (componentProps: IconProps, props = {}) => {
  return createElement(
    Icon,
    componentProps,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        fill="#353C4A"
        fillRule="evenodd"
        d="M20.184 21.598A10.46 10.46 0 0 1 13.5 24C7.701 24 3 19.299 3 13.5S7.701 3 13.5 3 24 7.701 24 13.5c0 2.54-.901 4.868-2.402 6.684l1.911 1.91a1 1 0 0 0 .193.151l1.556.934q.105.064.193.15l3.963 3.964a1 1 0 0 1 0 1.414l-.707.707a1 1 0 0 1-1.414 0l-3.963-3.963a1 1 0 0 1-.15-.193l-.935-1.556a1 1 0 0 0-.15-.193zM22 13.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0"
        clipRule="evenodd"
      />
    </svg>,
  );
};
export default SvgSearchIcon;
